import { toaster } from '@optiaxiom/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import http from '@frontend/api/http';
import { OPAL_URL } from '@frontend/envConfig';

export function useAppCompanionRuleDelete(agentId: string, onSuccess?: () => void) {
  const queryClient = useQueryClient();
  const { mutate, isPending, error } = useMutation({
    mutationFn: async (ruleId: string) => {
      return http.delete(`${OPAL_URL}/app-companion/agents/${agentId}/rules/${ruleId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['opal:app-companion', 'rules', agentId],
      });
      toaster.create('Rule deleted successfully', { type: 'success' });
      onSuccess?.();
    },
    onError: () => {
      toaster.create('Failed to delete rule', { type: 'danger' });
    },
  });
  return { mutate, isPending, error };
}
